import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { COLLECTIONS, USER_ACTIONS } from 'src/constants/constants';
import { queryKeys, requestCCApi } from 'src/utils';

import { narrativeGenerators } from '../../userActions/helper';

export const useDeleteProductVariation = (showSnackbarError = true) => {
  return useMutation({
    mutationFn: (payload: {
      index: number;
      productCode: string;
      groupProductCode: string;
      productVariationName: string;
      product_category_names: string[];
    }) => deleteProductVariation(payload, showSnackbarError),
    onSuccess: async () => {
      queryClient.refetchQueries(queryKeys.products.invalidateAll(), {
        type: 'active',
      });

      queryClient.removeQueries(queryKeys.products.invalidateAll(), {
        type: 'inactive',
      });
      queryClient.removeQueries(queryKeys.components.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.productPublications.invalidateAll(),
      );
    },
  });
};

const deleteProductVariation = async (
  payload: {
    index: number;
    productCode: string;
    groupProductCode: string;
    productVariationName: string;
    product_category_names: string[];
  },
  showSnackbarError = true,
) => {
  const narrative =
    payload.product_category_names.length > 0
      ? payload.product_category_names
          .map((category: string) =>
            (
              narrativeGenerators[COLLECTIONS.PRODUCTS][
                USER_ACTIONS.DELETE
              ] as (categoryName: string, productGroupName: string) => string
            )(category, payload.productVariationName as string),
          )
          .join(', ')
      : (
          narrativeGenerators[COLLECTIONS.PRODUCTS][USER_ACTIONS.DELETE] as (
            categoryName: string,
            productGroupName: string,
          ) => string
        )('', payload.productVariationName as string);

  const data = {
    data: [
      {
        resource: COLLECTIONS.PRODUCT_VARIATIONS,
        method: 'DELETE',
        id: payload.productCode,
        data: { narrative },
      },
    ],
  };

  if (payload.index === 0) {
    data.data.push({
      resource: COLLECTIONS.PRODUCTS,
      method: 'DELETE',
      id: payload.groupProductCode,
      data: { narrative },
    });
  }

  const response = await requestCCApi(
    {
      url: '/transaction',
      method: 'POST',
      data,
    },
    showSnackbarError,
  );

  return response;
};
